export default __webpack_public_path__ + "static/media/oie_KMyr2MhIYLv8.2a21403e.svg";